import { api } from 'api';
import {
  STATUS_COMPLETED,
  STATUS_DELIVERING,
  STATUS_ON_HOLD,
  STATUS_PROCESSING,
  STATUS_RETURNING,
  STATUS_SUBMITTED,
} from 'constants';
import { isEmpty, isObject } from 'lodash';
import { dispatchStore } from 'store';
import {
  SET_ALL_TRANSACTIONS_AS_CANCELLED,
  SET_REFERRAL_PARTICIPANTS,
  SET_TRANSACTIONS_COMPLETED_EMPTY,
  SET_TRANSACTIONS_EMPTY,
} from 'store/action';

export const fetchReferralLink = async (token) => {
  const { data } = await api.getReferralLink(token);
  return data?.referralURL || '';
};

export const handleGetReferralParticipants = async (token) => {
  const { data } = await api.getReferralParticipants(token);
  if (!isEmpty(data) && isObject(data)) {
    dispatchStore({ type: SET_REFERRAL_PARTICIPANTS, payload: data });
  }
};

export const handleGetTransactionsCompleted = async (token) => {
  const { data } = await api.searchTrans(token, {}, {}, 1, 1);
  if (!isEmpty(data)) {
    if (data?.empty) {
      dispatchStore({
        type: SET_TRANSACTIONS_EMPTY,
        payload: true,
      });
    } else {
      const { data: dataCompleted } = await api.searchTrans(
        token,
        { status: [STATUS_COMPLETED] },
        {},
        1,
        1
      );
      if (!isEmpty(dataCompleted)) {
        if (dataCompleted?.empty) {
          dispatchStore({
            type: SET_TRANSACTIONS_COMPLETED_EMPTY,
            payload: true,
          });
          const { data: dataWithoutCancelled } = await api.searchTrans(
            token,
            {
              status: [
                STATUS_SUBMITTED,
                STATUS_DELIVERING,
                STATUS_PROCESSING,
                STATUS_ON_HOLD,
                STATUS_RETURNING,
              ],
            },
            {},
            1,
            1
          );
          if (!isEmpty(dataWithoutCancelled)) {
            if (dataWithoutCancelled?.empty) {
              dispatchStore({
                type: SET_ALL_TRANSACTIONS_AS_CANCELLED,
                payload: true,
              });
            }
          }
        }
      }
    }
  }
};
